import SecondaryTickerTapeView from './SecondaryTickerTapeView';

export default SecondaryTickerTapeView;
